/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Completed_OnInputs */

const en_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed On`)
};

const fr_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé le`)
};

const de_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen am`)
};

const it_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completato il`)
};

const ru_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершено`)
};

const es_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completado el`)
};

const zh_cn2_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成`)
};

const ja_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了日`)
};

const hi_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर पूर्ण`)
};

const pt_pt2_completed_on = /** @type {(inputs: Completed_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído em`)
};

/**
* | output |
* | --- |
* | "Completed On" |
*
* @param {Completed_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const completed_on = /** @type {((inputs?: Completed_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Completed_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_completed_on(inputs)
	if (locale === "de") return de_completed_on(inputs)
	if (locale === "it") return it_completed_on(inputs)
	if (locale === "ru") return ru_completed_on(inputs)
	if (locale === "es") return es_completed_on(inputs)
	if (locale === "zh-CN") return zh_cn2_completed_on(inputs)
	if (locale === "ja") return ja_completed_on(inputs)
	if (locale === "hi") return hi_completed_on(inputs)
	if (locale === "pt-PT") return pt_pt2_completed_on(inputs)
	return en_completed_on(inputs)
});